export type TrustedScriptUrlValue = string | object;

type TrustedScriptUrlPolicy = {
  createScriptURL: (url: string) => TrustedScriptUrlValue;
};

type TrustedTypesWindow = Window & {
  trustedTypes?: {
    createPolicy: (
      name: string,
      rules: {
        createScriptURL: (url: string) => string;
      },
    ) => TrustedScriptUrlPolicy;
  };
};

const trustedScriptUrlPolicies = new Map<string, TrustedScriptUrlPolicy | null>();

export function installTrustedScriptUrlPolicy(
  policyName: string,
  validateUrl: (url: string) => string,
): TrustedScriptUrlPolicy | null {
  if (trustedScriptUrlPolicies.has(policyName)) {
    return trustedScriptUrlPolicies.get(policyName) ?? null;
  }

  const browserWindow = window as TrustedTypesWindow;
  if (!browserWindow.trustedTypes) {
    trustedScriptUrlPolicies.set(policyName, null);
    return null;
  }

  try {
    const policy = browserWindow.trustedTypes.createPolicy(policyName, {
      createScriptURL: validateUrl,
    });
    trustedScriptUrlPolicies.set(policyName, policy);
    return policy;
  } catch {
    trustedScriptUrlPolicies.set(policyName, null);
    return null;
  }
}

export function createTrustedScriptUrl(
  policyName: string,
  url: string,
  validateUrl: (url: string) => string,
): TrustedScriptUrlValue {
  const policy = installTrustedScriptUrlPolicy(policyName, validateUrl);
  if (!policy) {
    return validateUrl(url);
  }

  return policy.createScriptURL(url);
}
